export const CustomCardContent = {
  background: '#fff',
  border: '1px solid rgba(255, 255, 255, 0.3)',
  borderRadius: 14
};
